import React, {
    createContext,
    useReducer,
} from 'react';

import { detectMob } from 'components';

export interface RouterState {
    collapsed?: boolean
    theme?: string
    currentActiveMenu?: string
    pendingMainMenu ?: string
}

export const initialRouterState: RouterState = {
    collapsed: detectMob() ? true : false,
    theme: 'light',
    currentActiveMenu : null,
    pendingMainMenu : null
}

export enum ActionType {
    COLLAPSE_SIDEBAR,
    HIDE_SIDEBAR,
    CHANGE_THEME,
    CURRENT_ACTIVE_MENU,
    PENDING_MAIN_MENU
}

export interface Sidebar {
    type: ActionType;
    payload: RouterState;
}

export type RouterActions = Sidebar;

export function reducer(state: RouterState, action: RouterActions): RouterState {
    
    switch (action.type) {
        case ActionType.COLLAPSE_SIDEBAR:
            return { ...state, ...action.payload };
         case ActionType.CHANGE_THEME:
          return { ...state, ...action.payload };
          case ActionType.CURRENT_ACTIVE_MENU:
          return { ...state, ...action.payload };
          case ActionType.PENDING_MAIN_MENU:
          return { ...state, ...action.payload };
        default:
            return state;
    }
}


export const RouterContext = createContext<{
    state: RouterState;
    dispatch: React.Dispatch<RouterActions>;
}>({
    state: initialRouterState,
    dispatch: () => undefined,
});

export const setSidebar = ( value: boolean): Sidebar => ({
    type: ActionType.COLLAPSE_SIDEBAR,
    payload: { collapsed: value },
});

export const changeTheme = ( value: string): Sidebar => ({
  type: ActionType.CHANGE_THEME,
  payload: { theme: value },
});

export const currentActiveMenuItem = ( value: string): Sidebar => ({ 
  type: ActionType.CURRENT_ACTIVE_MENU,
  payload: { currentActiveMenu : value},
});

export const pendingMenuItem = ( value: string): Sidebar => ({ 
  type: ActionType.PENDING_MAIN_MENU,
  payload: { pendingMainMenu : value },
});

export const RouterContextProvider = (props) => {
    const [routerContextState, routerContextDispatch] = useReducer(reducer, initialRouterState);
    return (
      <RouterContext.Provider value={
        {
          ...props,
          dispatch: routerContextDispatch,
          state: { ...routerContextState },
        }
      }
      >
        {props.children}
      </RouterContext.Provider>
    );
  };
  
  export const RouterContextConsumer = Component => props => (
    <RouterContext.Consumer>
      {contexts => <Component {...props} {...contexts} />}
    </RouterContext.Consumer>
  );